import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import Layout from '../components/Layout';
import Login from '../pages/Login';
import TwoFactorVerify from '../pages/TwoFactorVerify';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import Assistants from '../pages/Assistants';
import AssistantCrons from '../pages/AssistantCrons';
import Sessions from '../pages/Sessions';
import KnowledgeBase from '../pages/KnowledgeBase';
import Appointments from '../pages/Appointments';
import Integrations from '../pages/Integrations';
import Promotions from '../pages/Promotions';
import Companies from '../pages/Companies';
import Participants from '../pages/Participants';
import Contacts from '../pages/Contacts';
import UserAccounts from '../pages/UserAccounts';
import Settings from '../pages/Settings';
import Catalog from '../pages/Catalog';
import MessageSchedules from '../pages/MessageSchedules';
import MessageTemplates from '../pages/MessageTemplates';
import MessageQueues from '../pages/MessageQueues';
import ChangePassword from '../pages/ChangePassword';
import EmailManagement from '../pages/EmailManagement';
import QrCodes from '../pages/QrCodes';
import FallbackRequests from '../pages/FallbackRequests';
import FallbackResponse from '../pages/FallbackResponse';
import FallbackRedirect from '../pages/FallbackRedirect';
import CalendarProfessionals from '../pages/CalendarProfessionals';
import CalendarServiceTypes from '../pages/CalendarServiceTypes';
import CalendarSchedule from '../pages/CalendarSchedule';
import CalendarBookings from '../pages/CalendarBookings';
import TimeConditions from '../pages/TimeConditions';
import QuickCopy from '../pages/QuickCopy';
import QuickCopyView from '../pages/QuickCopyView';
import Chat from '../pages/Chat';
import AlertResumes from '../pages/AlertResumes';
import WhatsappBalances from '../pages/WhatsappBalances';
import LeadGroups from '../pages/LeadGroups';
import Representatives from '../pages/Representatives';
import Leads from '../pages/Leads';
import Campaigns from '../pages/Campaigns';
import CampaignLeads from '../pages/CampaignLeads';
import Tickets from '../pages/Tickets';
import Surveys from '../pages/Surveys';
import SurveyResponsePage from '../pages/SurveyResponse';

function PrivateRoute() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/2fa-verify" element={<TwoFactorVerify />} />
      <Route path="/register" element={<Register />} />
      <Route path="/fallback-response/:id" element={<FallbackResponse />} />
      <Route path="/fr/:id" element={<FallbackRedirect />} />
      <Route path="/quick-copy/:publicKey" element={<QuickCopyView />} />
      <Route path="/survey/:id" element={<SurveyResponsePage />} />

      {/* Protected routes */}
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="assistants" element={<Assistants />} />
          <Route path="assistants/crons" element={<AssistantCrons />} />
          <Route path="assistants/chat" element={<Chat />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="knowledge-base" element={<KnowledgeBase />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="companies" element={<Companies />} />
          <Route path="participants" element={<Participants />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="user-accounts" element={<UserAccounts />} />
          <Route path="settings" element={<Settings />} />
          <Route path="catalog" element={<Catalog />} />
          <Route path="messages/schedules" element={<MessageSchedules />} />
          <Route path="messages/templates" element={<MessageTemplates />} />
          <Route path="messages/queues" element={<MessageQueues />} />
          <Route path="messages/tickets" element={<Tickets />} />
          <Route path="surveys" element={<Surveys />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="email/*" element={<EmailManagement />} />
          <Route path="qrcodes" element={<QrCodes />} />
          <Route path="fallback-requests" element={<FallbackRequests />} />
          <Route path="time-conditions" element={<TimeConditions />} />
          <Route path="quick-copy" element={<QuickCopy />} />
          <Route path="alert-resumes" element={<AlertResumes />} />
          <Route path="whatsapp/balances" element={<WhatsappBalances />} />
          <Route path="lead-groups" element={<LeadGroups />} />
          <Route path="representatives" element={<Representatives />} />
          <Route path="leads" element={<Leads />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="campaign-leads" element={<CampaignLeads />} />

          {/* Calendar routes */}
          <Route path="calendar/professionals" element={<CalendarProfessionals />} />
          <Route path="calendar/service-types" element={<CalendarServiceTypes />} />
          <Route path="calendar/bookings" element={<CalendarBookings />} />
          <Route path="calendar" element={<CalendarSchedule />} />
        </Route>
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
